import {
  Component,
  EventEmitter,
  Inject,
  OnInit,
  Output,
} from '@angular/core'
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButton } from '@angular/material/button'
import { MatProgressSpinner } from '@angular/material/progress-spinner'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatCardModule } from '@angular/material/card'
import { MatIcon } from '@angular/material/icon'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { MatExpansionModule } from '@angular/material/expansion'
import { MatInput } from '@angular/material/input'
import { MatDividerModule } from '@angular/material/divider'
import { NgxMaskDirective } from 'ngx-mask'
import {
  ErrorRequestModel,
  ResponseRequestModel,
} from '../../../../core/models/response.model'
import { SnackbarCustomService } from '../../../../shared/components/snackbar/snackbar-custom.service'
import { IndividualClientService } from '../../../../core/services/customer/individual-client/individual-client.service'
import { PersonLegalService } from '../../../../core/services/person/person-legal/person-legal.service'
import { BankDetailsClientEditComponent } from '../../../bank/bank-details-client-edit/bank-details-client-edit.component'
import { PaymentMethodsClientEditComponent } from '../../../payment/payment-client-edit/payment-methods-client-edit.component'
import { TaxDocumentClientEditComponent } from '../../../tax-document/tax-document-client-edit/tax-document-client-edit.component'
import { ContactClientEditComponent } from '../../../contact/contact-client-edit/contact-client-edit.component'
import { AddressClientEditComponent } from '../../../address/address-client-edit/address-client-edit.component'
import { SupplierService } from '../../../../core/services/person/supplier/supplier.service'
import { AuthService } from '../../../../core/services/auth/auth.service'
import { cnpjValidator } from '../../../../shared/utils/cnpj_validator'
import { cpfValidator } from '../../../../shared/utils/cpf_validator'
import { ResponsibleClientEditComponent } from '../../responsible-client-edit/responsible-client-edit.component'
import { DocumentUploadCreateComponent } from '../../../document/document-upload-create/document-upload-create.component'
import { DocumentUploadEditComponent } from '../../../document/document-upload-edit/document-upload-edit.component'
import { SupplierVehicleTypeComponent } from '../supplier-vehicle-type/supplier-vehicle-type.component'
import { PERFIL } from '../../../../core/constants/perfil.constants'

@Component({
  selector: 'supplier-edit',
  imports: [
    ReactiveFormsModule,
    MatButton,
    MatProgressSpinner,
    MatExpansionModule,
    MatFormFieldModule,
    MatCardModule,
    MatIcon,
    MatInput,
    // MatOption,
    // MatSelect,
    MatDividerModule,
    NgxMaskDirective,
    AddressClientEditComponent,
    ContactClientEditComponent,
    TaxDocumentClientEditComponent,
    PaymentMethodsClientEditComponent,
    BankDetailsClientEditComponent,
    ResponsibleClientEditComponent,
    DocumentUploadCreateComponent,
    DocumentUploadEditComponent,
    SupplierVehicleTypeComponent,
  ],
  templateUrl: './supplier-edit.component.html',
  styleUrl: './supplier-edit.component.scss',
  providers: [PersonLegalService, IndividualClientService],
  standalone: true,
})
export class SupplierEditComponent implements OnInit {
  constructor(
    private formBuilder: FormBuilder,
    private supplierService: SupplierService,
    private authService: AuthService,
    private snackbar: SnackbarCustomService,
    private dialogRef: MatDialogRef<SupplierEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.item = data.item
    if (data.type == 'legal-entity-client') {
      this.listTypeClient.push({ id: 'legal', description: 'Jurídica' })
    } else if (data.type == 'individual-client') {
      this.listTypeClient.push({
        id: 'natural',
        description: 'Fisica',
      })
    }
  }

  @Output() responseEdit = new EventEmitter()

  formLegalSupplier: FormGroup = new FormGroup({})
  formNaturalSupplier: FormGroup = new FormGroup({})
  listTypeClient: any = [
    // { id: 'legal', description: 'Pessoa Jurídica' },
    // { id: 'individual', description: 'Pessoa Fisica' },
  ]

  typeClient: 'legal' | 'natural' = 'legal'

  get isGestorReservaCompras(): boolean {
    return (
      this.authService.getInfosObject()?.idPerfil ==
      PERFIL.GESTOR_RESERVA_COMPRAS
    )
  }

  item: any
  loading = false
  loadingScreen = true

  vehicleTypeList: any[] = []

  panelAdress = false
  panelContact = false
  panelResponsable = false
  panelFinancial = false
  panelBankDetails = false
  panelDocument = false
  panelVehicleType = false

  ngOnInit(): void {
    this.createForm()
  }

  close() {
    this.dialogRef.close()
  }

  createForm(): void {
    this.formLegalSupplier = this.formBuilder.group({
      name: [this.item.nomeFantasia, [Validators.required]],
      cnpj: [this.item.cnpj, [Validators.required, cnpjValidator()]],
      corporate_name: [this.item.razaoSocial, [Validators.required]],
      reg_state: [this.item.inscricaoEstadual],
      reg_municipal: [this.item.inscricaoMunicipal],
      prazoPagamento: [
        {
          value: this.item.prazoPagamento ?? null,
          disabled: !this.isGestorReservaCompras,
        },
      ],
    })
    this.formNaturalSupplier = this.formBuilder.group({
      name: ['', [Validators.required]],
      cpf: ['', [Validators.required, cpfValidator()]],
      prazoPagamento: [
        {
          value: this.item.prazoPagamento ?? null,
          disabled: !this.isGestorReservaCompras,
        },
      ],
    })
    // A listagem de fornecedores já devolve os tipos de veículo em cada linha.
    // Cópia porque o painel altera o array no lugar e cancelar não pode mexer na linha do grid.
    this.vehicleTypeList = [...(this.item.tiposVeiculo ?? [])]
    this.loadingScreen = false
  }

  checkInvalidForm() {
    if (
      (this.typeClient == 'legal' && this.formLegalSupplier.invalid) ||
      (this.typeClient == 'natural' && this.formNaturalSupplier.invalid) ||
      // this.formFinancial.invalid ||
      this.loading
    ) {
      return true
    } else {
      return false
    }
  }

  editLegalModel() {
    return {
      id: this.item.id,
      pessoaJuridicaId: this.item.pessoaId,
      nome: this.formLegalSupplier.get('name')?.value ?? '',
      razaoSocial: this.formLegalSupplier.get('corporate_name')?.value ?? '',
      inscricaoMunicipal:
        this.formLegalSupplier.get('reg_municipal')?.value ?? '',
      inscricaoEstadual: this.formLegalSupplier.get('reg_state')?.value ?? '',
      cnpj: this.formLegalSupplier.get('cnpj')?.value ?? '',
      prazoPagamento: this.formLegalSupplier.get('prazoPagamento')?.value
        ? Number(this.formLegalSupplier.get('prazoPagamento')?.value)
        : null,
      ...this.vehicleTypesPayload(),
    }
  }

  // Sem tiposVeiculo na linha do grid não dá para saber o estado atual: omitir o
  // campo faz o back preservar os vínculos, enquanto enviar [] apagaria todos.
  vehicleTypesPayload() {
    if (!Array.isArray(this.item.tiposVeiculo)) {
      return {}
    }
    return { tiposVeiculoId: this.vehicleTypeList.map((ele: any) => ele.id) }
  }

  editIndividualModel() {
    return {
      id: this.item.id,
      pessoaId: this.item.pessoaId,
      nome: this.formNaturalSupplier.get('name')?.value ?? '',
      cpf: this.formNaturalSupplier.get('cpf')?.value ?? '',
      prazoPagamento: this.formNaturalSupplier.get('prazoPagamento')?.value
        ? Number(this.formNaturalSupplier.get('prazoPagamento')?.value)
        : null,
      ...this.vehicleTypesPayload(),
      // financeiro:{
      //  comissao: this.formFinancial.get('commission')?.value ?? '',
      //  divisao: this.formFinancial.get('divider')?.value ?? '',
      // },
    }
  }

  editSupplier() {
    this.loading = true
    if (this.typeClient == 'legal') {
      this.editSupplierLegal()
    } else if (this.typeClient == 'natural') {
      this.editSupplierNatural()
    } else {
      this.snackbar.error('Selecione um tipo de Fornecedor')
    }
  }

  editSupplierLegal() {
    this.supplierService.editSupplierLegal(this.editLegalModel()).subscribe({
      next: (response: ResponseRequestModel) => {
        this.snackbar.success(response.message)
        this.responseEdit.emit(true)
        this.close()
      },
      error: (err: ErrorRequestModel) => {
        this.loading = false
        this.snackbar.errorRequest(err)
      },
      complete: () => {
        this.loading = false
        this.formLegalSupplier.reset()
        this.formNaturalSupplier.reset()
      },
    })
  }

  editSupplierNatural() {
    this.supplierService
      .editSupplierNatural(this.editIndividualModel())
      .subscribe({
        next: (response: ResponseRequestModel) => {
          this.snackbar.success(response.message)
          this.responseEdit.emit(true)
          this.close()
        },
        error: (err: ErrorRequestModel) => {
          this.loading = false
          this.snackbar.errorRequest(err)
        },
        complete: () => {
          this.loading = false
          this.formLegalSupplier.reset()
          this.formNaturalSupplier.reset()
        },
      })
  }
}
